export default "https://cdn-static.gokick.com/assets/0ba7a9ad4dd7229a35aca69ca4183ecb31843a51/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";